import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../../store';
import { deleteMethod, get, post, put } from '../../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  loggedInSalary: [],
  selectedSalary: [],
  currentSalary: [],
  documentTypes: [],
  documents: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Salary',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET SalaryManagement
    getSalarySuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET SalaryManagement
    updateCurrentLoggedInSalaryData(state, action) {
      state.loggedInSalary = action.payload;
    },

    // GET SalaryManagement
    getCurrentSalarySuccess(state, action) {
      state.currentSalary = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    // GET SalaryManagement
    getSpecificSalaryDataSuccess(state, action) {
      state.selectedSalary = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    addOrUpdateSalarys(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getSalary(date) {
  return async () => {
    try {
      const response = await get(`Salary?date=${date}`);
      if (response.status) {
        dispatch(slice.actions.getSalarySuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSalaryById(userId) {
  return async () => {
    try {
      const response = await get(`SalaryById?token=${userId}`);
      if (response.status) {
        dispatch(slice.actions.getSalarySuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function generateSalary(body) {
  return async () => {
    try {
      const response = await post(`generateSalary?date=${body?.month}`);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSalarys(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addSalary(body) {
  return async () => {
    try {
      const response = await post(`Salary`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSalarys(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateSalary(body) {
  return async () => {
    try {
      const response = await put(`Salary`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSalarys(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteSalary(body) {
  return async () => {
    try {
      const response = await deleteMethod(`Salary`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSalarys(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
